// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2JPfL","form":"styles_form__1mYdo"};